import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import * as ProviderActions from "../../../../Redux/actions/providerActions";
import {
  getProvidersByClient,
  getTotalElements,
} from "../../../../Redux/reducer/providers";
import { Link } from "react-router-dom";
import FilterComponent from "../../../utils/searchBar";
import { MOD_CUSTOM, WRITE } from "../../../../permissions";
import { getRoles } from "../../../../Redux/reducer/session";
import { moduleAction, loadingHtml } from "../../../utils/functions";
import i18next from "i18next";
//COMPONENTS IMPORTS
import BlankProvider from "../../provider/providers/blankProviderBSC";
import TableProvidersByClient from "../../table/table-providers-client";
import Modal from "../../../utils/customModal";

//STATIC IMPORTS
import plusImage from "../../../../../static/images/plus.svg";
import { getFilters } from "../../../utils/utilities";

const filters = getFilters([
  { name: "name", property: "provider.institution.name", operator: "eq" },
  {
    name: "identification",
    property: "provider.institution.businessId",
    operator: "eq",
  },
]);

export class ProvidersClient extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: true,
      componentReady: false,
      page: 1,
      data: null,
      totalSize: 0,
      sizePerPage: 10,
      firstLoad: false,
      searchFilters: false,
    };
  }

  componentDidMount() {
    // Cargamos los proveedores
    const {
      actions: { getProvidersByClient },
    } = this.props;

    return getProvidersByClient(this.props.institution.company.id).then(() => {
      this.setState({ modal: false, componentReady: true, firstLoad: true });
    });
  }

  search = (searchProperty, searchTerm) => {
    const {
      actions: { getSearchContentProvidersClient, getProvidersByClient },
    } = this.props;

    if (searchTerm == "") {
      getProvidersByClient(this.props.institution.company.id);
      this.setState({ searchFilters: false });
    } else {
      var operator = "";

      filters.map((item) => {
        if (item.property == searchProperty) {
          operator = item.operator;
        }
      });

      var actionFilters = [
        { property: searchProperty, operator: operator, value: searchTerm },
      ];
      getSearchContentProvidersClient(
        this.props.institution.company.id,
        actionFilters
      );
      this.setState({ searchFilters: true });
    }
  };

  fetchData = (page, sizePerPage, filters) => {
    const {
      actions: { getProvidersByClient },
      institution,
    } = this.props;
    return getProvidersByClient(
      institution.company.id,
      page,
      sizePerPage,
      filters
    ).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  ProviderTable = () => {
    const { page, sizePerPage, firstLoad } = this.state;
    const { proveedores, totalElements } = this.props;

    if (firstLoad || (proveedores !== null && proveedores.length > 0)) {
      return (
        <TableProvidersByClient
          data={proveedores}
          page={page}
          getProvidersByClient={this.fetchData}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
        />
      );
    } else {
      return <BlankProvider />;
    }
  };

  loadProviders() {
    const { firstLoad } = this.state;
    const { proveedores } = this.props;

    return firstLoad || (proveedores !== null && proveedores.length > 0) ? (
      this.ProviderTable()
    ) : (
      <BlankProvider />
    );
  }

  render() {
    const { roles } = this.props;
    return (
      <React.Fragment>
        <ReactTitle title={`Gestión de Clientes - Proveedores`} />
        <div className="header-title flex-element">
          <div className="title gest-client flex-element">
            <div className="client-gest subtitle">
              {i18next.t("clients.providers.title")}
            </div>
          </div>
          <div className="actions flex-element">
            {moduleAction(roles, MOD_CUSTOM, WRITE) && (
              <Link
                to="/bscadministrator/providers/add"
                className="add-button flex-element"
              >
                <p className="bsc-add-client">
                  {i18next.t("clients.providers.add")}
                </p>
                <img src={plusImage} />
              </Link>
            )}
            <div className="filter">
              <FilterComponent filter={filters} searchFnc={this.search} />
            </div>
          </div>
        </div>
        {this.state.componentReady ? this.loadProviders() : null}
        <Modal show={this.state.modal}>{loadingHtml()}</Modal>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    institution: state.clientReducer.institution,
    roles: getRoles(state),
    proveedores: getProvidersByClient(state),
    totalElements: getTotalElements(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatch)(ProvidersClient);
